import {
  Rt
} from "./chunk.LTAMHVKK.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n,
  r as r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-play-pause-button/jb-play-pause-button.scss?inline
var jb_play_pause_button_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  --border-width: 2px;
  --icon-size: 16px;
  --icon-size-lg: 24px;
  --size: 40px;
  --size-lg: 64px;
}

button {
  align-items: center;
  background-color: transparent;
  block-size: var(--size);
  border: var(--border-width) solid var(--stroke-color, rgb(var(--rgb-primary, 20, 30, 85)));
  cursor: pointer;
  display: flex;
  inline-size: var(--size);
  justify-content: center;
  position: relative;
  transform: scale(1);
  transform-origin: 65% 50%;
  transition: transform 0.7s ease 0s;
}
@media (min-width: 1281px) {
  button {
    block-size: var(--size-lg);
    inline-size: var(--size-lg);
  }
}
button:hover {
  transform: scale3d(1.05, 1.05, 1);
}
button svg {
  block-size: var(--icon-size);
  fill: var(--stroke-color, rgb(var(--rgb-primary, 20, 30, 85)));
  inline-size: var(--icon-size);
}
@media (min-width: 1281px) {
  button svg {
    block-size: var(--icon-size-lg);
    inline-size: var(--icon-size-lg);
  }
}
button:not(.playing) svg.pause {
  display: none;
}
button.playing svg.play {
  display: none;
}`;

// src/components/jb-play-pause-button/jb-play-pause-button.ts
var JbPlayPauseButton = class extends h {
  constructor() {
    super(...arguments);
    this.spriteSvgUrl = "";
    this._playing = false;
  }
  setMediaElement(mediaElement) {
    this._mediaElement = mediaElement;
    this._mediaElement.addEventListener("play", () => {
      this._playing = true;
    });
    this._mediaElement.addEventListener("pause", () => {
      this._playing = false;
    });
    this._mediaElement.addEventListener("ended", () => {
      this._playing = false;
    });
  }
  _click() {
    if (!this._mediaElement) {
      return;
    }
    this._playing = !this._playing;
    if (this._playing) {
      this._mediaElement.play();
    } else {
      this._mediaElement.pause();
    }
  }
  _renderPauseButton() {
    if (this.spriteSvgUrl) {
      return ke` <svg class="pause"><use href=${this.spriteSvgUrl + "#plyr-pause"}></use></svg> `;
    }
    return ke`
      <svg
        class="pause"
        viewBox="0 0 18 18"
      >
        <rect
          x="4.35"
          y="2"
          width="2.3"
          height="14"
          rx=".245"
        ></rect>
        <rect
          x="11.35"
          y="2"
          width="2.3"
          height="14"
          rx=".245"
        ></rect>
      </svg>
    `;
  }
  _renderPlayButton() {
    if (this.spriteSvgUrl) {
      return ke` <svg class="play"><use href=${this.spriteSvgUrl + "#plyr-play"}></use></svg> `;
    }
    return ke`
      <svg
        class="play"
        viewBox="0 0 18 18"
      >
        <path
          d="M13.308 9.192l-6.345 6.345a.271.271 0 01-.463-.192V2.655a.271.271 0 01.463-.192l6.345 6.345a.271.271 0 010 .384z"
        ></path>
      </svg>
    `;
  }
  render() {
    return ke`<button
      aria-label="${this._playing ? this.ariaLabelPause ?? "Pause" : this.ariaLabelPlay ?? "Play"}"
      aria-pressed="${this._playing ? "true" : "false"}"
      @click=${this._click}
      class=${Rt({ playing: this._playing })}
    >
      ${this._renderPlayButton()} ${this._renderPauseButton()}
    </button>`;
  }
};
JbPlayPauseButton.styles = r(jb_play_pause_button_default);
__decorateClass([
  n()
], JbPlayPauseButton.prototype, "ariaLabelPause", 2);
__decorateClass([
  n()
], JbPlayPauseButton.prototype, "ariaLabelPlay", 2);
__decorateClass([
  n()
], JbPlayPauseButton.prototype, "spriteSvgUrl", 2);
__decorateClass([
  r2()
], JbPlayPauseButton.prototype, "_playing", 2);
JbPlayPauseButton = __decorateClass([
  customElement("jb-play-pause-button")
], JbPlayPauseButton);

export {
  JbPlayPauseButton
};
